import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export type ReservationSearchState = {
    reservationGuestSearch?: {
        restaurantId: string;
        date: string;
        search: string;
    };
};

const useReservationSearch = (restaurantId: string, date: string) => {
    const { state } = useLocation<ReservationSearchState>();
    const saved = state?.reservationGuestSearch;
    const restored =
        saved?.restaurantId === restaurantId && saved.date === date
            ? saved.search
            : null;
    const [search, setSearch] = useState<string | null>(restored);
    useEffect(() => {
        setSearch(restored);
    }, [restaurantId, date, restored]);
    return [search, setSearch] as const;
};

export default useReservationSearch;
